'use strict';

angular.module('uniromaLandingApp').controller('ScheduledJobDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ScheduledJob',
        function($scope, $stateParams, $uibModalInstance, entity, ScheduledJob) {

        $scope.scheduledJob = entity;
        $scope.load = function(id) {
            ScheduledJob.get({id : id}, function(result) {
                $scope.scheduledJob = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:scheduledJobUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.scheduledJob.id != null) {
                ScheduledJob.update($scope.scheduledJob, onSaveFinished);
            } else {
                ScheduledJob.save($scope.scheduledJob, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);
